import React, { useState } from "react";
import ProfileOtp from "./ProfileOtp";
import EditMobilePopup from "../../components/EditMobilePopup";
import { Dialog, DialogTitle, Typography } from "@mui/material";

const FlowOfProfile = ({ onClose, showMobileEditPopup }) => {
  const [page, setPage] = useState(0); // Page flow
  const [otpToken, setOtpToken] = useState(""); // 🔐 To store backend token
  const [mobile, setMobile] = useState(""); // 📱 To show on OTP screen
  const [countryCode, setCountryCode] = useState(""); // 🌍 To show on OTP screen
  return (
    <Dialog
      open={showMobileEditPopup}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={700} align="center">
          Update Mobile Number
        </Typography>
      </DialogTitle>
      {page === 0 && (
        <EditMobilePopup
          page={page}
          setPage={setPage}
          onClose={onClose}
          setOtpToken={setOtpToken}
          setMobile={setMobile}
          setCountryCode={setCountryCode}
        />
      )}

      {page === 1 && (
        <ProfileOtp
          setPage={setPage}
          onClose={() => setPage(0)}
          otpToken={otpToken} // ✅ Pass the token
          mobile={mobile} // ✅ To display mobile in UI
          countryCode={countryCode}
        />
      )}
    </Dialog>
  );
};

export default FlowOfProfile;
